/**
 * 클립보드에서 이미지만 추출한다. WaveX `tryPasteClipboardImageAsFile`과 같이
 * files/items를 모두 보고, 텍스트 paste는 건드리지 않는다.
 */
export function extractClipboardImageFiles(data: DataTransfer | null): File[] {
  if (!data) return [];
  const out: File[] = [];

  if (data.files?.length) {
    for (const file of Array.from(data.files)) {
      if (isLikelyClipboardImageFile(file)) out.push(file);
    }
  }

  if (out.length === 0 && data.items?.length) {
    for (const item of Array.from(data.items)) {
      if (item.kind !== "file") continue;
      const type = item.type;
      if (type.startsWith("image/") || type === "" || type === "application/octet-stream") {
        const file = item.getAsFile();
        if (file) out.push(file);
      }
    }
  }

  return out;
}

function isLikelyClipboardImageFile(file: File): boolean {
  if (file.type.startsWith("image/")) return true;
  if (!file.type || file.type === "application/octet-stream") {
    return /\.(png|jpe?g|gif|webp|svg|avif)$/i.test(file.name) || !file.name.includes(".");
  }
  return false;
}
